import { useEffect, useState } from 'react';
import { supabase } from '../../supabase';
import { useServicios } from './useServicios';
import { Container, Form, Button, Card, Row, Col, Table, Modal, Spinner, Alert } from 'react-bootstrap';
import { Pencil, PlusLg, Search, Trash, XCircle } from 'react-bootstrap-icons';
import dayjs from 'dayjs';
import Paginacion from '../../components/Paginacion';
import ResponsiveFilterCard from '../../components/ResponsiveFilterCard';
import ActiveFiltersLegend from '../../components/ActiveFiltersLegend';
import { esFechaISOValida, validarImporte } from '../../utils/vencimientosValidation';

const titulares = [
  'FERRERO/FINETTI', 'DELYAR SA', 'DIST. DEL ESTE', 'DEV RANDOM',
  'FERRERO', 'FINETTI', 'DON HECTOR', 'DOANET', 'MIRTA DEL VALLE BRAVO',
  'DESARROLLOS FORESTALES'
];

const tiposServicio = [
  'Rentas', 'Inmobiliario Municipal', 'Servicio', 'Telecomunicaciones',
  'Automotor', 'API', 'Inmobiliario Provincial', 'Tasas Rurales', 'Varios'
];

const proveedores = [
  'Personal', 'Telecom', 'Municipalidad de San Fco', 'Rentas Córdoba',
  'Municipalidad de Córdoba', 'Municipalidad de Carlos Paz',
  'API Santa Fe', 'AMOS', 'EPEC', 'EMUGAS', 'EPE', 'Tasas Rurales', 'Aguas Cordobesas',
  'ECOGAS', 'METROGAS', 'EDENOR', 'SANE-AYSA', 'UTE', 'Varios'
];

const periodos = [
  { label: 'Mensual', value: 30 },
  { label: 'Bimestral', value: 60 },
  { label: 'Trimestral', value: 90 },
  { label: 'Semestral', value: 180 },
  { label: 'Anual', value: 365 }
];

// cantidad de vencimientos por año según periodicidad
const valueToCantidad = { 30: 12, 60: 6, 90: 4, 180: 2, 365: 1 };

// Mapeo por label para preview
const periodicidadConfig = {
  'Mensual': { dias: 30, cantidad: 12 },
  'Bimestral': { dias: 60, cantidad: 6 },
  'Trimestral': { dias: 90, cantidad: 4 },
  'Semestral': { dias: 180, cantidad: 2 },
  'Anual': { dias: 365, cantidad: 1 }
};

const PAGE_SIZE_SERVICIOS = 50;
const EMPTY_SERVICE_FILTERS = {
  titular: '',
  tipo: '',
  proveedor: '',
  texto: ''
};

export default function ServiciosPage() {
  // FORMULARIO ALTA 
  const [form, setForm] = useState({
    id: null,
    tipo_servicio: '',
    titular: '',
    detalle: '',
    empresa_proveedora: '',
    referencia_cuenta: '',
    forma_pago: '',
    importe: '',
    periodicidad: '',
    cantidad_vencimientos: '',
    fecha_inicio: dayjs().format('YYYY-MM-DD'),
    notificar: true,
    observaciones: ''
  });

  const [modalMensaje, setModalMensaje] = useState({
    show: false,
    titulo: '',
    texto: '',
    tipo: 'success'
  });

  const [confirmando, setConfirmando] = useState(false);
  const [modalConfirm, setModalConfirm] = useState({
    show: false,
    titulo: '',
    texto: '',
    onConfirm: () => {}
  });
  
  const abrirConfirmacion = (titulo, texto, onConfirm) => {
    setConfirmando(false);
    setModalConfirm({ show: true, titulo, texto, onConfirm });
  };

  const mostrarMensaje = (titulo, texto, tipo = 'success') => {
    setModalMensaje({
      show: true,
      titulo,
      texto,
      tipo
    });
  };
 
  const [modalNuevo, setModalNuevo] = useState({
    show: false,
    borradorServicio: null,
    vencimientos: []
  });
 
  const [modalEditar, setModalEditar] = useState({
    show: false,
    servicio: null,
    vencimientos: [],
    loadingVencs: false
  });
 
  const [modalPreview, setModalPreview] = useState({
    show: false,
    año: null,
    periodicidadLabel: '',
    primerVto: '',
    vencs: []
  });

  const [filtros, setFiltros] = useState(EMPTY_SERVICE_FILTERS);
  const [filtrosBorrador, setFiltrosBorrador] = useState(EMPTY_SERVICE_FILTERS);

  const [anioAGenerar, setAnioAGenerar] = useState(null);

  const [paginaServicios, setPaginaServicios] = useState(1);

  const [showNuevoServicio, setShowNuevoServicio] = useState(false);
  const [guardandoNuevoServicio, setGuardandoNuevoServicio] = useState(false);

  const { servicios, mutateServicios, isLoading: serviciosLoading, error: serviciosError } = useServicios();

  const filteredServicios = servicios.filter(s => {
    const matchTitular = filtros.titular ? s.titular === filtros.titular : true;
    const matchTipo = filtros.tipo ? s.tipo_servicio === filtros.tipo : true;
    const matchProveedor = filtros.proveedor ? s.empresa_proveedora === filtros.proveedor : true;
    const matchTexto = filtros.texto
      ? (
        (s.detalle || '').toLowerCase().includes(filtros.texto.toLowerCase()) ||
        (s.referencia_cuenta || '').toLowerCase().includes(filtros.texto.toLowerCase()) ||
        (s.observaciones || '').toLowerCase().includes(filtros.texto.toLowerCase())
      )
      : true;

    return matchTitular && matchTipo && matchProveedor && matchTexto;
  });

  const totalPaginasServicios = Math.ceil(
    filteredServicios.length / PAGE_SIZE_SERVICIOS
  );

  const filtrosActivos = Object.values(filtrosBorrador).filter((valor) =>
    String(valor || '').trim()
  ).length;

  const activeFilterItems = [
    filtros.titular && { label: 'Titular', value: filtros.titular },
    filtros.tipo && { label: 'Tipo', value: filtros.tipo },
    filtros.proveedor && { label: 'Proveedor', value: filtros.proveedor },
    filtros.texto && { label: 'Buscar', value: filtros.texto },
  ].filter(Boolean);

  const serviciosPaginados = filteredServicios.slice(
    (paginaServicios - 1) * PAGE_SIZE_SERVICIOS,
    paginaServicios * PAGE_SIZE_SERVICIOS
  );

  useEffect(() => {
    setPaginaServicios(1);
  }, [filtros]);

  //  HANDLERS FORM PRINCIPAL 
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const nuevoValor = type === 'checkbox' ? checked : value;

    if (name === 'periodicidad') {
      const cantidad = valueToCantidad[value] ?? '';
      setForm(prev => ({
        ...prev,
        periodicidad: value,
        cantidad_vencimientos: cantidad
      }));
    } else {
      setForm(prev => ({ ...prev, [name]: nuevoValor }));
    }
  };

  // cuando hago "Guardar Servicio" NO guardo en BD,
  // abro el modal para cargar/ajustar los vencimientos
  const handleSubmit = (e) => {
    e.preventDefault();

    const {
      tipo_servicio,
      titular,
      detalle,
      empresa_proveedora,
      referencia_cuenta,
      forma_pago,
      periodicidad,
      fecha_inicio,
      notificar,
      importe,
      observaciones
    } = form;

    if (!periodicidad) {
      mostrarMensaje('Error', 'Debes Seleccionar la Periodicidad.', 'danger');
      return;
    }

    const periodicidadValue = parseInt(periodicidad, 10);
    const periodicidadLabel = periodos.find(p => p.value === periodicidadValue)?.label || '';
    const cantidad = valueToCantidad[periodicidadValue] || 0;

    if (!esFechaISOValida(fecha_inicio)) {
      mostrarMensaje('Fecha inválida', 'Ingresá una fecha de inicio válida.', 'danger');
      return;
    }
    const importeValidado = validarImporte(importe);
    if (!importeValidado.ok) {
      mostrarMensaje('Importe inválido', 'El importe debe ser un número igual o mayor a cero.', 'danger');
      return;
    }
    const fechaBase = dayjs(fecha_inicio);
    const importeBase = importeValidado.value ?? 0;

    const borradorServicio = {
      tipo_servicio,
      titular,
      detalle,
      empresa_proveedora,
      referencia_cuenta,
      forma_pago,
      periodicidad: periodicidadLabel,
      notificar,
      observaciones: observaciones || null,
      fecha_inicio
    };

    const vencimientos = Array.from({ length: cantidad }).map((_, i) => {
      const fecha = fechaBase.add(i * periodicidadValue, 'day');
      return {
        fecha_vencimiento: fecha.format('YYYY-MM-DD'),
        importe: importeBase
      };
    });

    setModalNuevo({
      show: true,
      borradorServicio,
      vencimientos
    });
  };

  const confirmarNuevoServicio = async () => {
    if (guardandoNuevoServicio) return;
    setGuardandoNuevoServicio(true);
    try {
      const { borradorServicio, vencimientos } = modalNuevo;

      if (!vencimientos.length || vencimientos.some((v) => !esFechaISOValida(v.fecha_vencimiento) || !validarImporte(v.importe).ok)) {
        throw new Error('Revisá las fechas y los importes de los vencimientos antes de guardar.');
      }
      // 1) insertar servicio
      const { data: nuevoServicio, error: errorServicio } = await supabase
        .from('servicios')
        .insert([{
          tipo_servicio: borradorServicio.tipo_servicio,
          titular: borradorServicio.titular,
          detalle: borradorServicio.detalle,
          empresa_proveedora: borradorServicio.empresa_proveedora,
          referencia_cuenta: borradorServicio.referencia_cuenta,
          forma_pago: borradorServicio.forma_pago,
          periodicidad: borradorServicio.periodicidad,
          cantidad_vencimientos: vencimientos.length,
          notificar: borradorServicio.notificar,
          activo: true,
          created_at: new Date(),
          observaciones: borradorServicio.observaciones
        }])
        .select()
        .single();

      if (errorServicio) throw errorServicio;

      // 2) insertar vencimientos asociados
      const payloadVenc = vencimientos.map((v, idx) => ({
        servicio_id: nuevoServicio.id,
        fecha_vencimiento: v.fecha_vencimiento,
        importe: v.importe !== '' && v.importe !== null ? parseFloat(v.importe) : null,
        pagado: false,
        aviso_enviado: false,
        notificar: borradorServicio.notificar ?? true,
        año: dayjs(v.fecha_vencimiento).year(),
        numero_periodo: idx + 1,
        periodo_label: borradorServicio.periodicidad
      }));

      const { error: errorVenc } = await supabase
        .from('vencimientos')
        .insert(payloadVenc);

      if (errorVenc) {
        const { error: rollbackError } = await supabase
          .from('servicios').delete().eq('id', nuevoServicio.id);
        if (rollbackError) {
          throw new Error(`Falló el alta de vencimientos y no se pudo revertir el servicio creado: ${errorVenc.message}. Revisá el servicio antes de reintentar. Error de reversión: ${rollbackError.message}`);
        }
        throw errorVenc;
      }

      mostrarMensaje('Servicio Creado', 'Servicio y Vencimientos Creados Correctamente.', 'success');

      // limpio estados
      setForm({
        id: null,
        tipo_servicio: '',
        titular: '',
        detalle: '',
        empresa_proveedora: '',
        referencia_cuenta: '',
        forma_pago: '',
        importe: '',
        periodicidad: '',
        cantidad_vencimientos: '',
        fecha_inicio: dayjs().format('YYYY-MM-DD'),
        notificar: true,
        observaciones: ''
      });
      setModalNuevo({ show: false, borradorServicio: null, vencimientos: [] });
      setShowNuevoServicio(false);

      mutateServicios();
    } catch (err) {
      console.error(err);
      mostrarMensaje('Error', 'Error al Guardar: ' + err.message, 'danger');
    } finally {
      setGuardandoNuevoServicio(false);
    }
  };

  const handleEditar = async (servicio) => {
    setModalEditar({
      show: true,
      servicio: { ...servicio },
      servicioOriginal: { ...servicio },
      vencimientos: [],
      loadingVencs: true
    });

    const { data: vencs, error } = await supabase
      .from('vencimientos')
      .select('id, fecha_vencimiento, importe, notificar, pagado, aviso_enviado, año, numero_periodo, periodo_label')
      .eq('servicio_id', servicio.id)
      .order('fecha_vencimiento', { ascending: true });

    if (error) {
      console.error(error);
      mostrarMensaje('Error', 'No se pudieron cargar los Vencimientos.', 'danger');
      setModalEditar(prev => ({ ...prev, loadingVencs: false }));
      return;
    }

    const normalizados = (vencs || []).map(v => ({
      ...v,
      fecha_vencimiento: v.fecha_vencimiento || '',
      original: {
        fecha_vencimiento: v.fecha_vencimiento || '', 
        importe: v.importe
      }
    }));

    setModalEditar(prev => ({
      ...prev,
      vencimientos: normalizados,
      loadingVencs: false
    }));
  };

  const vencimientoTieneCambios = (v) => {
    if (!v.original) return false;
    const originalImporte = validarImporte(v.original.importe);
    const importeActual = validarImporte(v.importe);
    return (
      v.fecha_vencimiento !== v.original.fecha_vencimiento ||
      !importeActual.ok || !originalImporte.ok ||
      importeActual.value !== originalImporte.value
    );
  };

  const servicioTieneCambios = () => {
    const { servicio, servicioOriginal } = modalEditar;
    if (!servicio || !servicioOriginal) return false;

    return (
      servicio.titular !== servicioOriginal.titular ||
      servicio.tipo_servicio !== servicioOriginal.tipo_servicio ||
      servicio.empresa_proveedora !== servicioOriginal.empresa_proveedora ||
      servicio.detalle !== servicioOriginal.detalle ||
      servicio.referencia_cuenta !== servicioOriginal.referencia_cuenta ||
      servicio.forma_pago !== servicioOriginal.forma_pago ||
      servicio.periodicidad !== servicioOriginal.periodicidad
    );
  };

  const setVencField = (idx, field, value) => {
    setModalEditar(prev => {
      const copy = [...prev.vencimientos];
      copy[idx] = { ...copy[idx], [field]: value };
      return { ...prev, vencimientos: copy };
    });
  };

  const guardarVencimiento = async (idx) => {
    const v = modalEditar.vencimientos[idx];
    try {
      if (!esFechaISOValida(v.fecha_vencimiento)) {
        throw new Error('La fecha de vencimiento no es válida.');
      }
      const importe = validarImporte(v.importe);
      if (!importe.ok) throw new Error('El importe debe ser un número igual o mayor a cero.');
      const payload = {
        fecha_vencimiento: v.fecha_vencimiento,
        año: Number(v.fecha_vencimiento.slice(0, 4)),
        importe: importe.value
      };
      const { error } = await supabase
        .from('vencimientos')
        .update(payload)
        .eq('id', v.id);

      if (error) throw error;
      setModalEditar((prev) => ({
        ...prev,
        vencimientos: prev.vencimientos.map((actual) => actual.id === v.id
          ? { ...actual, ...payload, original: { fecha_vencimiento: payload.fecha_vencimiento, importe: payload.importe } }
          : actual),
      }));
      mostrarMensaje('Éxito', 'Vencimiento Actualizado.', 'success');
    } catch (err) {
      console.error(err);
      mostrarMensaje('Error', 'Error al Actualizar Vencimiento: ' + err.message, 'danger');
    }
  };

  const eliminarVencimiento = (id) => {
    abrirConfirmacion(
      'Eliminar Vencimiento',
      '¿Seguro querés eliminar este vencimiento?',
      async () => {
        const { error } = await supabase
          .from('vencimientos')
          .delete()
          .eq('id', id);

        if (error) {
          setModalMensaje({
            show: true,
            titulo: 'Error',
            texto: 'No se pudo eliminar el vencimiento.',
            tipo: 'danger'
          });
          return;
        }

        setModalEditar(prev => ({
          ...prev,
          vencimientos: prev.vencimientos.filter(v => v.id !== id)
        }));
      }
    );
  };

  const eliminarVencimientosDeAnio = (anio) => {
    abrirConfirmacion(
      'Eliminar Año Completo',
      `¿Confirmás eliminar TODOS los vencimientos del año ${anio}?`,
      async () => {
        try {
          const servicio = modalEditar.servicio;
          if (!servicio) return;

          // eliminar en supabase
          const { error } = await supabase
            .from('vencimientos')
            .delete()
            .eq('servicio_id', servicio.id)
            .eq('año', anio);

          if (error) throw error;

          // actualizar estado local
          setModalEditar(prev => ({
            ...prev,
            vencimientos: prev.vencimientos.filter(v => v.año !== anio)
          }));

          mostrarMensaje('Eliminado', `Se eliminaron todos los vencimientos del año ${anio}.`, 'success');
        } catch (err) {
          console.error(err);
          mostrarMensaje('Error', 'No se pudieron eliminar los vencimientos. ' + err.message, 'danger');
        }
      }
    );
  };

  const agregarVencimientoAlAnio = async (anio) => {
    try {
      const servicio = modalEditar.servicio;

      const vencsDeAnio = modalEditar.vencimientos.filter(v => v.año === anio);
      const siguienteNumeroPeriodo =
        vencsDeAnio.length > 0
          ? Math.max(...vencsDeAnio.map(v => v.numero_periodo || 0)) + 1
          : 1;

      const periodicidadLabel = servicio.periodicidad;

      const nuevo = {
        servicio_id: servicio.id,
        fecha_vencimiento: `${anio}-01-01`,
        importe: 0,
        pagado: false,
        aviso_enviado: false,
        notificar: servicio.notificar ?? true,
        año: anio,
        numero_periodo: siguienteNumeroPeriodo,
        periodo_label: periodicidadLabel
      };

      const { data, error } = await supabase
        .from('vencimientos')
        .insert([nuevo])
        .select()
        .single();

      if (error) throw error;

      setModalEditar(prev => ({
        ...prev,
        vencimientos: [
          ...prev.vencimientos,
          {
            ...data,
            fecha_vencimiento: dayjs(data.fecha_vencimiento).format('YYYY-MM-DD'),
            original: { fecha_vencimiento: data.fecha_vencimiento, importe: data.importe }
          }
        ]
      }));

    } catch (err) {
      console.error(err);
      mostrarMensaje('Error', 'Error al Agregar Vencimiento: ' + err.message, 'danger');
    }
  };

  const handleEliminar = (id) => {
    abrirConfirmacion(
      'Eliminar Servicio',
      '¿Confirmás eliminar este servicio y todos sus vencimientos?',
      async () => {
        try {
          // Nunca informar éxito si alguna eliminación fue rechazada por RLS o por la red.
          const { error: errorVencimientos } = await supabase
            .from('vencimientos').delete().eq('servicio_id', id);
          if (errorVencimientos) throw errorVencimientos;

          const { error: errorServicio } = await supabase
            .from('servicios').delete().eq('id', id);
          if (errorServicio) throw errorServicio;

          await mutateServicios();
          mostrarMensaje('Eliminado', 'El servicio fue eliminado correctamente.', 'success');
        } catch (error) {
          mostrarMensaje('Error', `No se pudo completar la eliminación: ${error.message}`, 'danger');
          await mutateServicios();
        }
      }
    );
  };

  const agruparPorAnio = (vencs) => {
    const grupos = {};
    vencs.forEach(v => {
      const anio = v.año || dayjs(v.fecha_vencimiento).year();
      if (!grupos[anio]) grupos[anio] = [];
      grupos[anio].push(v);
    });
    return grupos;
  };

  const generarVencimientosParaAnio = (anio) => {
    try {
      const servicio = modalEditar.servicio;
      if (!servicio) return;

      const periodicidadLabel = servicio.periodicidad;
      const cfg = periodicidadConfig[periodicidadLabel];

      if (!cfg) {
        mostrarMensaje('Error', `La periodicidad "${periodicidadLabel}" no es válida para generar vencimientos.`, 'danger');
        return;
      }

      const yaExiste = modalEditar.vencimientos.some(v => v.año === anio);
      if (yaExiste) {
        mostrarMensaje('Error', `El Año ${anio} ya tiene Vencimientos. Podés editarlos, crear o eliminar, pero no regenerarlos.`, 'danger');
        return;
      }

      const defaultPrimerVto = `${anio}-01-01`;
      const base = dayjs(defaultPrimerVto);

      const vencs = Array.from({ length: cfg.cantidad }).map((_, i) => ({
        fecha_vencimiento: base.add(i * cfg.dias, 'day').format('YYYY-MM-DD'),
        importe: 0
      }));

      setModalPreview({
        show: true,
        año: anio,
        periodicidadLabel,
        primerVto: defaultPrimerVto,
        vencs
      });
    } catch (err) {
      console.error(err);
      mostrarMensaje('Error', 'Error al Preparar Preview: ' + err.message, 'danger');
    }
  };

  const recalcularPreviewDesdePrimeraFecha = () => {
    setModalPreview(prev => {
      const { primerVto, periodicidadLabel } = prev;
      const cfg = periodicidadConfig[periodicidadLabel];
      if (!primerVto || !cfg) return prev;

      const base = dayjs(primerVto);
      const vencs = Array.from({ length: cfg.cantidad }).map((_, i) => ({
        fecha_vencimiento: base.add(i * cfg.dias, 'day').format('YYYY-MM-DD'),
        importe: 0
      }));

      return { ...prev, vencs };
    });
  };

  const confirmarPreviewGeneracion = async () => {
    try {
      const { año, periodicidadLabel, vencs } = modalPreview;
      const servicio = modalEditar.servicio;
      if (!servicio) return;

      if (vencs.some((v) => !esFechaISOValida(v.fecha_vencimiento) || !validarImporte(v.importe).ok)) {
        throw new Error('Todos los vencimientos deben tener una fecha válida y un importe no negativo.');
      }
      const listos = vencs
        .map((v, idx) => ({
          servicio_id: servicio.id,
          fecha_vencimiento: v.fecha_vencimiento,
          importe: v.importe !== '' && v.importe !== null ? parseFloat(v.importe) : null,
          pagado: false,
          aviso_enviado: false,
          notificar: servicio.notificar ?? true,
          año: Number(v.fecha_vencimiento.slice(0, 4)),
          numero_periodo: idx + 1,
          periodo_label: periodicidadLabel
        }));

      if (listos.length === 0) {
        mostrarMensaje('Error', 'Debes tener al menos un vencimiento con fecha para guardar.', 'danger');
        return;
      }

      const { data, error } = await supabase
        .from('vencimientos')
        .insert(listos)
        .select();

      if (error) throw error;

      const normalizados = data.map(d => ({
        ...d,
        fecha_vencimiento: d.fecha_vencimiento
          ? dayjs(d.fecha_vencimiento).format('YYYY-MM-DD')
          : '',
        original: { fecha_vencimiento: d.fecha_vencimiento, importe: d.importe }
      }));

      setModalEditar(prev => ({
        ...prev,
        vencimientos: [...prev.vencimientos, ...normalizados]
      }));

      setModalPreview({
        show: false,
        año: null,
        periodicidadLabel: '',
        primerVto: '',
        vencs: []
      });

      mostrarMensaje('Éxito', `Vencimientos del Año ${año} Creados Correctamente.`, 'success');
    } catch (err) {
      console.error(err);
      mostrarMensaje('Error', 'Error al Generar Vencimientos: ' + err.message, 'danger');
    }
  };

  const cerrarPreview = () => {
    setModalPreview({
      show: false,
      año: null,
      periodicidadLabel: '',
      primerVto: '',
      vencs: []
    });
  };

  // años existentes en modalEditar (para no regenerar)
  const añosExistentesEditar = [...new Set(modalEditar.vencimientos.map(v => v.año))].filter(Boolean);

  //  RENDER 
  return (
    <Container fluid className='servicios-wrapper'>
      {/* ALTA DE SERVICIO */}
      <header className='crm-page-header servicios-header-actions'>
        <div className='crm-page-heading'>
          <h1 className='crm-page-title'>Gestión de Servicios</h1>
          <p className='crm-page-subtitle'>
            Administrá servicios, impuestos y sus vencimientos asociados.
          </p>
        </div>

        <div className='crm-page-actions'>
          <Button
            variant='primary'
            className='servicios-btn-nuevo'
            onClick={() => setShowNuevoServicio(true)}
          >
            <PlusLg aria-hidden='true' />
            Registrar nuevo servicio
          </Button>
        </div>
      </header>

      <Modal
        show={showNuevoServicio}
        onHide={() => setShowNuevoServicio(false)}
        size='lg'
        centered
        scrollable
      >
        <Modal.Header closeButton>
          <Modal.Title>Registrar Nuevo Servicio</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col xs={12} md={6}>
                <Form.Group className='mb-3'>
                  <Form.Label>Titular</Form.Label>
                  <Form.Select
                    name='titular'
                    value={form.titular}
                    onChange={handleChange}
                    required
                  >
                    <option value=''>Seleccionar...</option>
                    {titulares.map((t) => (
                      <option key={t} value={t}>
                        {t}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>

                <Form.Group className='mb-3'>
                  <Form.Label>Tipo de Servicio / Impuesto</Form.Label>
                  <Form.Select
                    name='tipo_servicio'
                    value={form.tipo_servicio}
                    onChange={handleChange}
                    required
                  >
                    <option value=''>Seleccionar...</option>
                    {tiposServicio.map((s) => (
                      <option key={s} value={s}>
                        {s}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>

                <Form.Group className='mb-3'>
                  <Form.Label>Proveedor</Form.Label>
                  <Form.Select
                    name='empresa_proveedora'
                    value={form.empresa_proveedora}
                    onChange={handleChange}
                    required
                  >
                    <option value=''>Seleccionar...</option>
                    {proveedores.map((p) => (
                      <option key={p} value={p}>
                        {p}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>

                <Form.Group className='mb-3'>
                  <Form.Label>Detalle</Form.Label>
                  <Form.Control
                    name='detalle'
                    value={form.detalle}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>

                <Form.Group className='mb-3'>
                  <Form.Label>Referencia / Nº de Cuenta</Form.Label>
                  <Form.Control
                    name='referencia_cuenta'
                    value={form.referencia_cuenta}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>

                <Form.Group className='mb-3'>
                  <Form.Label>Forma de Pago</Form.Label>
                  <Form.Control
                    name='forma_pago'
                    value={form.forma_pago}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>

              <Col xs={12} md={6}>
                <Form.Group className='mb-3'>
                  <Form.Label>Importe Estimado</Form.Label>
                  <Form.Control
                    type='number'
                    min={0}
                    name='importe'
                    value={form.importe}
                    onChange={handleChange}
                    required
                    onWheel={(e) => e.target.blur()}
                  />
                </Form.Group>

                <Form.Group className='mb-3'>
                  <Form.Label>Fecha del Primer Vencimiento</Form.Label>
                  <Form.Control
                    type='date'
                    name='fecha_inicio'
                    value={form.fecha_inicio}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>

                <Form.Group className='mb-3'>
                  <Form.Label>Periodicidad</Form.Label>
                  <Form.Select
                    name='periodicidad'
                    value={form.periodicidad}
                    onChange={handleChange}
                    required
                  >
                    <option value=''>Seleccionar...</option>
                    {periodos.map((p) => (
                      <option key={p.value} value={p.value}>
                        {p.label}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>

                <Form.Group className='mb-3'>
                  <Form.Label>Cantidad de Vencimientos por Año</Form.Label>
                  <Form.Control
                    type='number'
                    min={1}
                    name='cantidad_vencimientos'
                    value={form.cantidad_vencimientos}
                    onChange={handleChange}
                    disabled
                    onWheel={(e) => e.target.blur()}
                  />
                </Form.Group>

                <Form.Group className='mb-3'>
                  <Form.Label>Observaciones</Form.Label>
                  <Form.Control
                    as='textarea'
                    rows={2}
                    name='observaciones'
                    value={form.observaciones}
                    onChange={handleChange}
                  />
                </Form.Group>

                <Form.Check
                  type='checkbox'
                  label='Notificar 5 días antes'
                  name='notificar'
                  checked={form.notificar}
                  onChange={handleChange}
                />
              </Col>
            </Row>

            <div className='d-flex flex-column flex-sm-row justify-content-end gap-2 mt-4'>
              <Button
                variant='secondary'
                type='button'
                onClick={() => setShowNuevoServicio(false)}
              >
                Cancelar
              </Button>

              <Button type='submit' variant='primary'>
                Continuar
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      {/* MODAL NUEVO -> CARGAR VENCIMIENTOS */}
      <Modal
        show={modalNuevo.show}
        onHide={() => setModalNuevo({ show: false, borradorServicio: null, vencimientos: [] })}
        size='lg'
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Cargar Vencimientos del Servicio</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className='mb-2'>
            <strong>Titular:</strong> {modalNuevo.borradorServicio?.titular} &nbsp;|&nbsp;
            <strong>Servicio:</strong> {modalNuevo.borradorServicio?.tipo_servicio} &nbsp;|&nbsp;
            <strong>Proveedor:</strong> {modalNuevo.borradorServicio?.empresa_proveedora} &nbsp;|&nbsp;
            <strong>Detalle:</strong> {modalNuevo.borradorServicio?.detalle} &nbsp;|&nbsp;
            <strong>Referencia:</strong> {modalNuevo.borradorServicio?.referencia_cuenta} &nbsp;|&nbsp;
            <strong>Forma de Pago:</strong> {modalNuevo.borradorServicio?.forma_pago} &nbsp;|&nbsp;
          </p>
          <div className='table-responsive'>
            <Table bordered hover size='sm' className='align-middle mb-0'>
              <thead className='table-light'>
                <tr>
                  <th>#</th>
                  <th>Fecha</th>
                  <th>Importe</th>
                </tr>
              </thead>
              <tbody>
                {modalNuevo.vencimientos.map((v, idx) => (
                  <tr key={idx}>
                    <td>{idx + 1}</td>
                    <td className='servicios-vencimiento-fecha-cell'>
                      <Form.Control
                        type='date'
                        value={v.fecha_vencimiento}
                        onChange={(e) => {
                          const val = e.target.value;
                          setModalNuevo(prev => {
                            const copy = [...prev.vencimientos];
                            copy[idx] = { ...copy[idx], fecha_vencimiento: val };
                            return { ...prev, vencimientos: copy };
                          });
                        }}
                      />
                    </td>
                    <td className='servicios-vencimiento-importe-cell'>
                      <Form.Control
                        type='number'
                        step='0.01'
                        min='0'
                        value={v.importe}
                        onChange={(e) => {
                          const val = e.target.value;
                          setModalNuevo(prev => {
                            const copy = [...prev.vencimientos];
                            copy[idx] = { ...copy[idx], importe: val };
                            return { ...prev, vencimientos: copy };
                          });
                        }}
                        onWheel={(e) => e.target.blur()}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </Modal.Body>
        <Modal.Footer className='flex-column flex-sm-row'>
          <Button
            variant='secondary'
            disabled={guardandoNuevoServicio}
            onClick={() => setModalNuevo({ show: false, borradorServicio: null, vencimientos: [] })}
          >
            Cancelar
          </Button>
          <Button variant='primary' disabled={guardandoNuevoServicio} onClick={confirmarNuevoServicio}>
            {guardandoNuevoServicio ? 'Guardando...' : 'Confirmar y Guardar'}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* MODAL EDICIÓN SERVICIO + VENCIMIENTOS */}
      <Modal
        show={modalEditar.show}
        onHide={() => setModalEditar({ show: false, servicio: null, vencimientos: [], loadingVencs: false })}
        size='lg'
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Editar Servicio</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {modalEditar.servicio && (
            <>
              <Form
                className='mb-3'
                onSubmit={(e) => {
                  e.preventDefault();
                  abrirConfirmacion(
                    'Guardar Cambios del Servicio',
                    '¿Confirmás actualizar los datos del servicio?',
                    async () => {
                      const s = modalEditar.servicio;
                      try {
                        const { error } = await supabase
                          .from('servicios')
                          .update({
                            titular: s.titular,
                            tipo_servicio: s.tipo_servicio,
                            empresa_proveedora: s.empresa_proveedora,
                            detalle: s.detalle,
                            referencia_cuenta: s.referencia_cuenta,
                            forma_pago: s.forma_pago,
                            periodicidad: s.periodicidad
                          })
                          .eq('id', s.id);

                        if (error) throw error;

                        mostrarMensaje('Éxito', 'Servicio Actualizado Correctamente.', 'success');
                        // Actualizar el "servicioOriginal" dentro del modal para que
                        // la función servicioTieneCambios() deje de reportar cambios
                        // una vez guardado (botón pase a disabled).
                        setModalEditar(prev => ({
                          ...prev,
                          servicioOriginal: { ...s },
                          servicio: { ...s }
                        }));
                        mutateServicios();
                      } catch (err) {
                        mostrarMensaje('Error', 'Error al Actualizar el Servicio: ' + err.message, 'danger');
                      }
                    }
                  );
                }}
              >
                <Row>
                  <Col md={4}>
                    <Form.Group className='mb-2'>
                      <Form.Label>Titular</Form.Label>
                      <Form.Select
                        value={modalEditar.servicio.titular}
                        onChange={(e) =>
                          setModalEditar(prev => ({
                            ...prev,
                            servicio: { ...prev.servicio, titular: e.target.value }
                          }))
                        }
                      >
                        <option value=''>Seleccionar...</option>
                        {titulares.map(t => <option key={t} value={t}>{t}</option>)}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group className='mb-2'>
                      <Form.Label>Tipo de Servicio</Form.Label>
                      <Form.Select
                        value={modalEditar.servicio.tipo_servicio}
                        onChange={(e) =>
                          setModalEditar(prev => ({
                            ...prev,
                            servicio: { ...prev.servicio, tipo_servicio: e.target.value }
                          }))
                        }
                      >
                        <option value=''>Seleccionar...</option>
                        {tiposServicio.map(t => <option key={t} value={t}>{t}</option>)}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group className='mb-2'>
                      <Form.Label>Proveedor</Form.Label>
                      <Form.Select
                        value={modalEditar.servicio.empresa_proveedora}
                        onChange={(e) =>
                          setModalEditar(prev => ({
                            ...prev,
                            servicio: { ...prev.servicio, empresa_proveedora: e.target.value }
                          }))
                        }
                      >
                        <option value=''>Seleccionar...</option>
                        {proveedores.map(p => <option key={p} value={p}>{p}</option>)}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md={4}>
                    <Form.Group className='mb-2'>
                      <Form.Label>Detalle</Form.Label>
                      <Form.Control
                        value={modalEditar.servicio.detalle || ''}
                        onChange={(e) =>
                          setModalEditar(prev => ({
                            ...prev,
                            servicio: { ...prev.servicio, detalle: e.target.value }
                          }))
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group className='mb-2'>
                      <Form.Label>Referencia / Nº de Cuenta</Form.Label>
                      <Form.Control
                        value={modalEditar.servicio.referencia_cuenta || ''}
                        onChange={(e) =>
                          setModalEditar(prev => ({
                            ...prev,
                            servicio: { ...prev.servicio, referencia_cuenta: e.target.value }
                          }))
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group className='mb-2'>
                      <Form.Label>Forma de Pago</Form.Label>
                      <Form.Control
                        value={modalEditar.servicio.forma_pago || ''}
                        onChange={(e) =>
                          setModalEditar(prev => ({
                            ...prev,
                            servicio: { ...prev.servicio, forma_pago: e.target.value }
                          }))
                        }
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Form.Group className='mb-2'>
                    <Form.Label>Periodicidad</Form.Label>

                    <div className='d-flex align-items-center gap-2'>
                      <Form.Select
                        value={modalEditar.servicio.periodicidad}
                        onChange={(e) =>
                          setModalEditar(prev => ({
                            ...prev,
                            servicio: { ...prev.servicio, periodicidad: e.target.value }
                          }))
                        }
                      >
                        <option value=''>Seleccionar...</option>
                        {['Mensual','Bimestral','Trimestral','Semestral','Anual'].map(p => (
                          <option key={p} value={p}>{p}</option>
                        ))}
                      </Form.Select>

                      <small className='text-muted'>
                        Cambiar la periodicidad no modifica vencimientos existentes.
                      </small>
                    </div>
                  </Form.Group>
                </Row>
                <Button
                  type='submit'
                  variant='primary'
                  size='sm'
                  className='mt-2'
                  disabled={!servicioTieneCambios()}
                >
                  Guardar Cambios de Servicio
                </Button>
              </Form>

              <h5 className='fw-bold mt-3'>Vencimientos</h5>

              <div className='mt-3 p-2 border rounded'>
                <h6 className='fw-bold'>Generar Vencimientos para un Año Específico</h6>

                <div className='d-flex gap-2 align-items-center mt-2'>
                  <Form.Select
                    className='servicios-anio-select'
                    value={anioAGenerar || ''}
                    onChange={(e) => {
                      const val = e.target.value ? parseInt(e.target.value) : null;
                      setAnioAGenerar(val);
                    }}
                  >
                    <option value=''>Seleccionar Año...</option>
                    {Array.from({ length: 10 }).map((_, i) => {
                      const año = dayjs().year() + i;
                      if (añosExistentesEditar.includes(año)) return null;
                      return (
                        <option key={año} value={año}>
                          {año}
                        </option>
                      );
                    })}
                  </Form.Select>

                  <Button
                    variant='outline-primary'
                    size='sm'
                    disabled={!anioAGenerar}
                    onClick={() => generarVencimientosParaAnio(anioAGenerar)}
                  >
                    Generar Preview
                  </Button>
                </div>
                <small className='text-muted d-block mt-1'>
                  Solo se muestran años que aún no tienen vencimientos.
                </small>
              </div>

              {modalEditar.loadingVencs ? (
                <div className='d-flex align-items-center gap-2 mt-3'>
                  <Spinner size='sm' /> <span>Cargando Vencimientos...</span>
                </div>
              ) : (
                <>
                  {Object.entries(agruparPorAnio(modalEditar.vencimientos))
                    .sort(([a], [b]) => a - b)
                    .map(([anio, vencs]) => (
                      <div key={anio} className='mb-4 p-2 border rounded mt-3'>
                        <h6 className='fw-bold text-primary'>Año {anio}</h6>

                        <div className='table-responsive'>
                          <Table bordered hover size='sm' className='align-middle mb-0'>
                            <thead className='table-light'>
                              <tr>
                                <th>Fecha</th>
                                <th>Importe</th>
                                <th className='text-center'>Acciones</th>
                              </tr>
                            </thead>

                            <tbody>
                              {vencs.map(v => {
                                const idx = modalEditar.vencimientos.findIndex(x => x.id === v.id);
                                return (
                                  <tr key={v.id}>
                                    <td>
                                      <Form.Control
                                        type='date'
                                        value={v.fecha_vencimiento || ''}
                                        onChange={(e) =>
                                          setVencField(idx, 'fecha_vencimiento', e.target.value)
                                        }
                                      />
                                    </td>

                                    <td>
                                      <Form.Control
                                        type='number'
                                        step='0.01'
                                        min='0'
                                        value={v.importe ?? ''}
                                        onChange={(e) =>
                                          setVencField(idx, 'importe', e.target.value)
                                        }
                                      />
                                    </td>

                                    <td className='text-center'>
                                      <Button
                                        variant='primary'
                                        size='sm'
                                        className='me-2'
                                        disabled={!vencimientoTieneCambios(v)}
                                        onClick={() =>
                                          abrirConfirmacion(
                                            'Guardar cambios',
                                            '¿Confirmás actualizar este vencimiento?',
                                            () => guardarVencimiento(idx)
                                          )
                                        }
                                      >
                                        Guardar
                                      </Button>

                                      <Button
                                        variant='danger'
                                        size='sm'
                                        onClick={() => eliminarVencimiento(v.id)}
                                      >
                                        Eliminar
                                      </Button>
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </Table>
                        </div>

                        <Button
                          className='mt-2 me-2'
                          variant='outline-danger'
                          size='sm'
                          onClick={() => eliminarVencimientosDeAnio(parseInt(anio))}
                        >
                          Eliminar Año Completo
                        </Button>

                        <Button
                          className='mt-2'
                          variant='outline-primary'
                          size='sm'
                          onClick={() => agregarVencimientoAlAnio(parseInt(anio))}
                        >
                          + Agregar Vencimiento al Año {anio}
                        </Button>

                      </div>
                    ))}
                </>
              )}
            </>
          )}
        </Modal.Body>
      </Modal>

      {/* MODAL PREVIEW NUEVO AÑO */}
      <Modal
        show={modalPreview.show}
        onHide={cerrarPreview}
        size='lg'
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Preview Vencimientos {modalPreview.año} ({modalPreview.periodicidadLabel})
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Row className='mb-3'>
            <div className='d-flex align-items-center gap-2'>
              <Form.Group>
                <Form.Label>Fecha del Primer Vencimiento</Form.Label>
                <Form.Control
                  type='date'
                  value={modalPreview.primerVto || ''}
                  onChange={(e) =>
                    setModalPreview(prev => ({ ...prev, primerVto: e.target.value }))
                  }
                />
                <small className='text-muted'>
                    A partir de esta fecha se calculan los demás vencimientos.
                </small>
              </Form.Group>
              <Button
                className='mt-1'
                variant='outline-primary'
                onClick={recalcularPreviewDesdePrimeraFecha}
                disabled={!modalPreview.primerVto}
              >
                  Regenerar desde Primera Fecha
              </Button>
            </div>
          </Row>

          <div className='table-responsive'>
            <Table bordered hover size='sm' className='align-middle mb-0'>
              <thead className='table-light'>
                <tr>
                  <th>#</th>
                  <th>Fecha</th>
                  <th>Importe</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {modalPreview.vencs.map((v, idx) => (
                  <tr key={idx}>
                    <td>{idx + 1}</td>
                    <td>
                      <Form.Control
                        type='date'
                        value={v.fecha_vencimiento || ''}
                        onChange={(e) => {
                          const val = e.target.value;
                          setModalPreview(prev => {
                            const copy = [...prev.vencs];
                            copy[idx] = { ...copy[idx], fecha_vencimiento: val };
                            return { ...prev, vencs: copy };
                          });
                        }}
                      />
                    </td>
                    <td>
                      <Form.Control
                        type='number'
                        step='0.01'
                        min='0'
                        value={v.importe ?? ''}
                        onChange={(e) => {
                          const val = e.target.value;
                          setModalPreview(prev => {
                            const copy = [...prev.vencs];
                            copy[idx] = { ...copy[idx], importe: val };
                            return { ...prev, vencs: copy };
                          });
                        }}
                        onWheel={(e) => e.target.blur()}
                      />
                    </td>
                    <td className='text-center'>
                      <Button
                        variant='outline-danger'
                        size='sm'
                        onClick={() =>
                          abrirConfirmacion(
                            'Eliminar Vencimiento',
                            '¿Confirmás eliminar este vencimiento del preview?',
                            () => {
                              setModalPreview(prev => ({
                                ...prev,
                                vencs: prev.vencs.filter((_, i) => i !== idx)
                              }));
                            }
                          )
                        }
                      >
                        Eliminar
                      </Button>
                    </td>
                  </tr>
                ))}

                {modalPreview.vencs.length === 0 && (
                  <tr>
                    <td colSpan={4} className='text-center text-muted py-3'>
                      No hay vencimientos generados aún. Elegí una fecha de inicio y presioná
                      &nbsp;<strong>Regenerar desde primera fecha</strong>.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>

          <Button
            className='mt-2'
            variant='outline-primary'
            size='sm'
            onClick={() =>
              setModalPreview(prev => ({
                ...prev,
                vencs: [...prev.vencs, { fecha_vencimiento: '', importe: 0 }]
              }))
            }
          >
            + Agregar Vencimiento Manual
          </Button>
        </Modal.Body>

        <Modal.Footer className='flex-column flex-sm-row'>
          <Button variant='secondary' onClick={cerrarPreview}>
            Cancelar
          </Button>
          <Button variant='primary' onClick={confirmarPreviewGeneracion}>
            Confirmar y Guardar
          </Button>
        </Modal.Footer>
      </Modal>

      {/* LISTADO DE SERVICIOS ACTIVOS */}
      <ResponsiveFilterCard
        className='servicios-filter-card'
        title='Filtros de servicios'
        activeCount={filtrosActivos}
      >
        <div className='crm-filter-heading'>
          <span>Consulta</span>
          <h2>Filtros de búsqueda</h2>
        </div>

        <Row className='servicios-filter-grid g-2 align-items-end'>
          <Col xs={12} sm={6} lg={3}>
            <Form.Label>Titular</Form.Label>
            <Form.Select
              value={filtrosBorrador.titular}
              onChange={(e) => setFiltrosBorrador(prev => ({ ...prev, titular: e.target.value }))}
            >
              <option value=''>Todos</option>
              {[...new Set(servicios.map(s => s.titular))].map(t => (
                <option key={t} value={t}>{t}</option>
              ))}
            </Form.Select>
          </Col>

          <Col xs={12} sm={6} lg={3}>
            <Form.Label>Tipo de servicio</Form.Label>
            <Form.Select
              value={filtrosBorrador.tipo}
              onChange={(e) => setFiltrosBorrador(prev => ({ ...prev, tipo: e.target.value }))}
            >
              <option value=''>Todos</option>
              {[...new Set(servicios.map(s => s.tipo_servicio))].map(t => (
                <option key={t} value={t}>{t}</option>
              ))}
            </Form.Select>
          </Col>

          <Col xs={12} sm={6} lg={3}>
            <Form.Label>Proveedor</Form.Label>
            <Form.Select
              value={filtrosBorrador.proveedor}
              onChange={(e) => setFiltrosBorrador(prev => ({ ...prev, proveedor: e.target.value }))}
            >
              <option value=''>Todos</option>
              {[...new Set(servicios.map(s => s.empresa_proveedora))].map(p => (
                <option key={p} value={p}>{p}</option>
              ))}
            </Form.Select>
          </Col>

          <Col xs={12} sm={6} lg={3}>
            <Form.Label>Buscar</Form.Label>
            <Form.Control
              placeholder='Buscar por Detalle, Referencia, Observaciones'
              value={filtrosBorrador.texto}
              onChange={(e) => setFiltrosBorrador(prev => ({ ...prev, texto: e.target.value }))}
              onKeyDown={(e) => {
                if (e.key === 'Enter') setFiltros({ ...filtrosBorrador });
              }}
            />
          </Col>

        </Row>

        <div className='crm-filter-actions-row'>
          <Button
            variant='outline-primary'
            onClick={() => {
              setFiltrosBorrador({ ...EMPTY_SERVICE_FILTERS });
              setFiltros({ ...EMPTY_SERVICE_FILTERS });
            }}
          >
            <XCircle aria-hidden='true' />
            Limpiar filtros
          </Button>
          <Button
            variant='primary'
            onClick={() => setFiltros({ ...filtrosBorrador })}
          >
            <Search aria-hidden='true' />
            Aplicar filtros
          </Button>
        </div>
      </ResponsiveFilterCard>

      <ActiveFiltersLegend items={activeFilterItems} />

      {serviciosError && (
        <Alert variant='danger' role='alert' className='mb-3'>
          No se pudieron cargar los servicios: {serviciosError.message}
          <Button size='sm' variant='outline-danger' className='ms-2' onClick={() => mutateServicios()}>
            Reintentar
          </Button>
        </Alert>
      )}
      <Card className='servicios-table-card'>
        <div className='crm-results-header'>
          <div>
            <span>Resultados</span>
            <h2>Servicios activos</h2>
            <p>{serviciosLoading ? 'Cargando servicios...' : serviciosError ? 'No se pudo consultar el listado.' : `${filteredServicios.length} servicio${filteredServicios.length === 1 ? '' : 's'} encontrado${filteredServicios.length === 1 ? '' : 's'}.`}</p>
          </div>
        </div>

        {totalPaginasServicios > 1 && (
          <div className='crm-table-pagination is-top'>
            <Paginacion
              pagina={paginaServicios}
              totalPaginas={totalPaginasServicios}
              onChange={setPaginaServicios}
            />
          </div>
        )}

        <div className='d-none d-md-block table-responsive'>
          <Table
            striped
            hover
            responsive
            size='sm'
            className='servicios-table align-middle text-center mb-0'
          >
            <thead className='table-light'>
              <tr className='text-nowrap text-center'>
                <th>Titular</th>
                <th>Servicio / Proveedor</th>
                <th>Detalle</th>
                <th>Referencia</th>
                <th>Forma Pago</th>
                <th>Periodicidad</th>
                <th>Observaciones</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {filteredServicios.length === 0 ? (
                <tr>
                  <td colSpan={8} className='text-center text-muted py-4'>
                    {serviciosLoading ? <><Spinner size='sm' animation='border' className='me-2' /> Cargando servicios...</> : serviciosError ? 'Error al cargar los servicios.' : 'No hay servicios encontrados'}
                  </td>
                </tr>
              ) : (
                serviciosPaginados.map(s => (
                  <tr key={s.id}>
                    <td>{s.titular}</td>
                    <td>{`${s.tipo_servicio} / ${s.empresa_proveedora}`}</td>
                    <td>{s.detalle}</td>
                    <td>{s.referencia_cuenta}</td>
                    <td>{s.forma_pago}</td>
                    <td>{s.periodicidad}</td>
                    <td className='servicios-observaciones-cell'>
                      {s.observaciones || '—'}
                    </td>
                    <td className='text-center'>
                      <div className='servicios-acciones'>
                        <Button variant='outline-primary' size='sm' title='Editar servicio' onClick={() => handleEditar(s)}>
                          <Pencil />
                        </Button>
                        <Button variant='outline-danger' size='sm' title='Eliminar servicio' onClick={() => handleEliminar(s.id)}>
                          <Trash />
                        </Button>
                      </div>
                    </td>
                  </tr>
                )))}
            </tbody>
          </Table>
        </div>

        <div className='servicios-mobile-list d-md-none'>
          {filteredServicios.length === 0 ? (
            <div className='servicios-mobile-empty text-muted' role='status'>
              {serviciosLoading ? 'Cargando servicios...' : serviciosError ? 'Error al cargar los servicios.' : 'No hay servicios encontrados'}
            </div>
          ) : (
            serviciosPaginados.map((s) => (
              <Card key={s.id} className='servicios-mobile-card'>
                <Card.Body>
                  <div className='servicios-mobile-card-header'>
                    <div>
                      <h6 className='servicios-mobile-title'>
                        {s.tipo_servicio || 'Sin servicio'}
                      </h6>

                      <p className='servicios-mobile-subtitle mb-0'>
                        {s.empresa_proveedora || 'Sin proveedor'}
                      </p>
                    </div>

                    <span className='badge text-bg-primary'>
                      {s.periodicidad || '-'}
                    </span>
                  </div>

                  <div className='servicios-mobile-info'>
                    <div>
                      <span>Titular</span>
                      <strong>{s.titular || '-'}</strong>
                    </div>

                    <div>
                      <span>Detalle</span>
                      <strong>{s.detalle || '-'}</strong>
                    </div>

                    <div>
                      <span>Referencia</span>
                      <strong>{s.referencia_cuenta || '-'}</strong>
                    </div>

                    <div>
                      <span>Forma de pago</span>
                      <strong>{s.forma_pago || '-'}</strong>
                    </div>

                    <div>
                      <span>Observaciones</span>
                      <strong>{s.observaciones || '—'}</strong>
                    </div>
                  </div>

                  <div className='servicios-mobile-actions'>
                    <Button
                      variant='outline-primary'
                      size='sm'
                      onClick={() => handleEditar(s)}
                    >
                      <Pencil className='me-1' />
                      Editar
                    </Button>

                    <Button
                      variant='outline-danger'
                      size='sm'
                      onClick={() => handleEliminar(s.id)}
                    >
                      <Trash className='me-1' />
                      Eliminar
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            ))
          )}
        </div>

        {totalPaginasServicios > 1 && (
          <div className='crm-table-pagination is-bottom'>
            <Paginacion
              pagina={paginaServicios}
              totalPaginas={totalPaginasServicios}
              onChange={setPaginaServicios}
            />
          </div>
        )}

      </Card>

      <Modal show={modalMensaje.show} onHide={() => setModalMensaje(prev => ({ ...prev, show: false }))} centered>
        <Modal.Header closeButton className={modalMensaje.tipo === 'danger' ? 'bg-danger text-white' : 'bg-success text-white'}>
          <Modal.Title>{modalMensaje.titulo}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{modalMensaje.texto}</p>
        </Modal.Body>
        <Modal.Footer className='flex-column flex-sm-row'>
          <Button variant='secondary' onClick={() => setModalMensaje(prev => ({ ...prev, show: false }))}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={modalConfirm.show} onHide={() => !confirmando && setModalConfirm(prev => ({ ...prev, show: false }))} centered>
        <Modal.Header closeButton>
          <Modal.Title>{modalConfirm.titulo}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>{modalConfirm.texto}</p>
        </Modal.Body>

        <Modal.Footer className='flex-column flex-sm-row'>
          <Button variant='secondary' disabled={confirmando} onClick={() => setModalConfirm(prev => ({ ...prev, show: false }))}>
            Cancelar
          </Button>

          <Button
            variant='danger'
            disabled={confirmando}
            onClick={async () => {
              setConfirmando(true);
              try {
                await modalConfirm.onConfirm();
              } catch (error) {
                mostrarMensaje('Error', error.message || 'No se pudo completar la operación.', 'danger');
              } finally {
                setConfirmando(false);
                setModalConfirm(prev => ({ ...prev, show: false }));
              }
            }}
          >
            {confirmando ? 'Procesando...' : 'Confirmar'}
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
}
